export default {
    key:'entity_admin',
    dashboard: {
        component:'MarketIndex',
        links: {
            sidebar:[
                {
                    icon:'fas fa-fw fa-tachometer-alt',
                    text:'Entities',
                    route:'/entity_admin',
                    active:'entities'
                },
                {
                    icon:'fa fa-user-cog',
                    text:'settings',
                    route:'/settings',
                    active:'settings'
                }
            ]
        }
    }
}